<footer class="bg-dark text-light py-3">
  <div class="container text-center">
    <p class="mb-0">© 2023 HMC IT Network Services. All Rights Reserved.</p>
    <p class="mb-0">Created by Thilina Harshana</p>
  </div>
</footer>
